import Vue from 'vue'
import Router from 'vue-router'
import Signin from '../views/Signin';
import SubmissionDetails from '../views/SubmissionDetails';
import Settings from '../views/Settings';
import Forms from '../views/Forms';
import Dashboard from '../views/Dashboard';
import ManageRooms from '../views/ManageRooms';
import Reservations from '../views/Reservations';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Signin',
      path: '/signin',
      component: Signin,
    },
    {
      title: 'Dashboard',
      name: 'Dashboard',
      path: '/forms',
      component: Dashboard,
      //beforeEnter: validateToken,
    },
    {
      title: 'Forms',
      name: 'Forms',
      path: '/forms/list',
      component: Forms,
      //beforeEnter: validateToken,
    },
    {
      name: 'FilledFormAnalytics',
      path: '/forms/analytics',
      component: () => import('../views/FormAnalytics'),
      //beforeEnter: validateToken
    },
    {
      name: 'Settings',
      path: '/forms/settings',
      component: Settings,
      //beforeEnter: validateToken
    },
    {
      name: 'ManageRooms',
      path: '/forms/manage-rooms',
      component: ManageRooms,
      //beforeEnter: validateToken
    },
    {
      name: 'Reservations',
      path: '/forms/reservations',
      component: Reservations,
      //beforeEnter: validateToken
    },
    {
      name: 'FormSubmissions',
      path: '/forms/:id',
      component: () => import('../views/FormFilled'),
      //beforeEnter: validateToken
    },
    {
      name: 'FormPreview',
      path: '/forms/:id/preview',
      component: () => import('../views/FormPreview'),
      //beforeEnter: validateToken
    },
    {
      name: 'FormFieldsEdit',
      path: '/forms/:id/fields',
      component: () => import('../views/FormFieldsEdit'),
      //beforeEnter: validateToken
    },
    {
      name: 'FilledFormDetails',
      path: '/forms/:id/:filledId',
      component: SubmissionDetails,
      //beforeEnter: validateToken
    },
    {
      path: '/*',
      redirect: '/forms'
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js